import { ObjectId } from '@racemap/sdk/schema/base';
import { EventTypes } from '@racemap/sdk/schema/events';
import { isAtomicEvent } from '@racemap/utilities/functions/utils';
import type { RacemapEventCommon } from '@racemap/utilities/types/events';
import { Button, Flex } from 'antd';
import type { FC } from 'react';
import { useNavigate } from 'react-router';
import { IconPlus } from 'src/components/BasicComponents/Icons';
import { GroupEventList } from 'src/components/EventEditor/BasicTab/GroupEventList';
import { StageEventList } from 'src/components/EventEditor/BasicTab/StageEventList';
import { SearchEvent } from 'src/components/SearchEvent';
import { useChildEventsInStore } from 'src/lib/customHooks/useChildEventsInStore';
import { useCurrentEvent } from 'src/lib/customHooks/useCurrentEvent';
import { useStore } from 'src/store/reducers';

export const ChildEventsList: FC = () => {
  const currentEvent = useCurrentEvent();
  const navigate = useNavigate();
  const childEvents = useChildEventsInStore(currentEvent?.id);
  const { addContests } = useStore((s) => s.events.actions);

  if (currentEvent == null) return null;

  const handleEventFound = async (newChild: RacemapEventCommon | null) => {
    if (newChild == null || currentEvent == null) return;
    if (!isAtomicEvent(newChild)) return;

    await addContests([new ObjectId(newChild.id)], new ObjectId(currentEvent.id));
  };

  return (
    <Flex vertical gap={8}>
      {currentEvent.type === EventTypes.CONTEST_GROUP && (
        <Flex gap={8}>
          <SearchEvent
            onSelect={handleEventFound}
            filter="can-edit"
            show={['hidden', 'regulareventsonly']}
            ignoreList={childEvents.map((e) => e.id)}
          />
        </Flex>
      )}
      {currentEvent.type === EventTypes.STAGE_GROUP && (
        <Flex gap={8}>
          <Button
            icon={<IconPlus />}
            onClick={() => navigate(`/admin/stagegroups/${currentEvent.id}/stages/new`)}
          >
            Create Stage
          </Button>
        </Flex>
      )}
      {currentEvent.type === EventTypes.STAGE_GROUP ? <StageEventList /> : <GroupEventList />}
    </Flex>
  );
};
